import { useState } from 'react';
import { Modal, Spinner, Typography } from '@weareopenr/component-library';
import { IMealtimeDetailsFlow, IMealtimeDetailsModal, MealtimeSteps } from './types';
import ModalImg from 'src/assets/images/section-modal.png';
import styles from './MealtimeDetailsModal.module.scss';
import MealtimeView from './MealtimeView/MealtimeView';
import AssignCategoriesView from './AssignCategoriesView/AssignCategoriesView';
import { useCategories } from 'src/hooks/useCategories/useCategories';
import { getModalTitle } from 'src/helpers/getModalTitle';

const MealtimeFlow = ({ menuId, onModalClose, mealtimes }: IMealtimeDetailsFlow) => {
  const steps = [MealtimeSteps.AddMealtimes, MealtimeSteps.AssignCategory];
  const [step, setStep] = useState<MealtimeSteps>(MealtimeSteps.AddMealtimes);
  const [mealtimeId, setMealtimeId] = useState<string>('');

  const { isLoading, data } = useCategories(menuId);

  return (
    <>
      <Typography className={styles.header}>{getModalTitle(steps, step)}</Typography>
      {step === MealtimeSteps.AddMealtimes && (
        <MealtimeView
          type="create"
          onSuccess={() => setStep(MealtimeSteps.AssignCategory)}
          menuId={menuId}
          mealtimes={mealtimes}
          onModalClose={onModalClose}
          setMealtimeId={setMealtimeId}
        />
      )}
      {step === MealtimeSteps.AssignCategory &&
        (isLoading ? (
          <div className={styles.spinner} data-testid="mealtimes-loading">
            <Spinner size="xlarge" colour="rainbow" />
          </div>
        ) : (
          <AssignCategoriesView
            categoriesData={data}
            closeModal={onModalClose}
            mealtimeId={mealtimeId}
            menuId={menuId}
          />
        ))}
    </>
  );
};

const MealtimeDetailsModal = ({ isModalOpen, onModalClose, menuId, mealtimes }: IMealtimeDetailsModal) => {
  return (
    <Modal open={isModalOpen} closeModal={onModalClose} image={ModalImg} imageAlt="Picture of table with plates">
      <MealtimeFlow onModalClose={onModalClose} menuId={menuId} mealtimes={mealtimes} />
    </Modal>
  );
};

export default MealtimeDetailsModal;
